import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import logger from '../utils/logger.js';

/**
 * Create and configure the MCP server instance
 * @returns Configured MCP server instance
 */
export function createMcpServer(): McpServer {
  logger.info('Creating MCP server instance');
  
  const server = new McpServer({
    name: 'Artillery Performance Testing',
    version: '1.0.0',
    description: 'MCP server for generating and running Artillery performance tests'
  });
  
  return server;
}

/**
 * Initialize the MCP server with all resources, tools, and prompts
 * @param server MCP server instance
 */
export async function initializeMcpServer(server: McpServer): Promise<void> {
  logger.info('Initializing MCP server with resources, tools, and prompts');
  
  // Register resources, tools, and prompts
  
  // Import and register resources
  const { registerResources } = await import('../resources/index.js');
  await registerResources(server);
  
  // Import and register tools
  // Ensure the path is correct and the file exists; update the path if necessary
  const { registerTools } = await import('../tools/index.js');
  await registerTools(server);
  
  // Import and register prompts
  const { registerPrompts } = await import('../prompts/index.js');
  await registerPrompts(server);
  
  logger.info('MCP server initialization completed');
}
